<template>
  <highcharts :options="chartOptions"></highcharts>
</template>

<script>

import {Chart} from 'highcharts-vue'
import Highcharts from 'highcharts'
import funnelInit from 'highcharts/modules/funnel'

funnelInit(Highcharts)

export default {
  props: {
    data: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: 'funnel',
          marginRight: 200,
          marginTop: 30,
          height: 330
        },
        title: {
          text: '',
          x: -50
        },
        credits: {
          enabled: false
        },
        colors: ['#48A1FF', '#5ACB74', '#FED066', '#FF7C41', '#396AFC', '#9861E6', '#F3667C'],
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              crop : false,
              overflow: 'none',
              format: '<b>{point.name}</b> ({point.showValue:,.2f}万元)',
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
              softConnector: true,
              distance: 100,
            },
            neckWidth: '30%',
            neckHeight: '18%'
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          pointFormat: '<b>{point.showValue:,.2f}万元</b>'
        },
        series: [{
          name: '商机',
          data: [
          ]
        }]
      }
    }
  },
  mounted() {
  },
  components: {
    highcharts: Chart
  },
  beforeDestroy() {
  },
  watch: {
    data (val) {
      this.setData(val);
    }
  },
  methods: {
    setData(data) {
      this.chartOptions.series[0].data = this.getFunnelData(data)
    },
    getFunnelData(originData) {
      let min = 0.05
      let sum = 0
      originData.forEach(item => {
        sum += item.value
      });
      sum = sum === 0 ? 1 : sum
      let funnelData = []
      originData.forEach(item => {
        funnelData.push({
          name: item.name,
          showValue: item.value,
          y: min + item.value / sum
        })
      });
      return funnelData;
    }
  }
}
</script>
